<script setup>
import { ref, onMounted } from 'vue';
import { useScrollAnimations } from '@/composables/useScrollAnimations';

const { animateInView, slideUp } = useScrollAnimations();
const sectionRef = ref(null);
const contentRef = ref(null);
const videoRef = ref(null);

onMounted(() => {
    if (sectionRef.value) {
        animateInView(sectionRef.value, () => {
            if (contentRef.value) slideUp(contentRef.value);
            if (videoRef.value) slideUp(videoRef.value, 0.3);
        }, 0.1);
    }
});
</script>

<template>
    <div class="py-24" ref="sectionRef">
        <div class="mx-auto max-w-7xl px-6 lg:px-8 text-center">

            <!-- Content Group -->
            <div ref="contentRef" class="opacity-0 mb-16 max-w-7xl mx-auto">
                <h2 class="text-3xl font-bold tracking-tight text-white sm:text-5xl mb-8"
                    v-html="$t('landingPage.v2.video.title')">
                </h2>

                <p class="text-xl text-white leading-relaxed mb-8" v-html="$t('landingPage.v2.video.description1')">
                </p>

                <p class="text-lg text-gray-400 leading-relaxed max-w-7xl mx-auto"
                    v-html="$t('landingPage.v2.video.description2')">
                </p>
            </div>

            <!-- Video Placeholder -->
            <div ref="videoRef"
                class="opacity-0 relative w-full aspect-video bg-black rounded-2xl overflow-hidden border border-white/10 shadow-2xl flex items-center justify-center group cursor-pointer">
                <!-- Placeholder Content -->
                <div class="text-center">
                    <div
                        class="w-20 h-20 bg-white/10 rounded-full flex items-center justify-center mb-4 mx-auto group-hover:bg-white/20 transition-colors backdrop-blur-sm">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2"
                            stroke="currentColor" class="w-8 h-8 text-white ml-1">
                            <path stroke-linecap="round" stroke-linejoin="round"
                                d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z" />
                        </svg>
                    </div>
                    <span class="text-2xl font-bold text-white tracking-widest uppercase">{{
                        $t('landingPage.v2.video.placeholderRef') }}</span>
                </div>

                <!-- Optional: Abstract background glow behind video -->
                <div
                    class="absolute -inset-[100px] bg-teal-500/20 blur-[100px] rounded-[50%] pointer-events-none -z-10 opacity-50">
                </div>
            </div>

        </div>
    </div>
</template>

<style scoped></style>